import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// USER PAGES
import Home from "./pages/Home";
import Login from "./pages/Login";
import Builds from "./pages/Builds";
import BuildStatus from "./pages/BuildStatus";
import Downloads from "./pages/Downloads";
import Previews from "./pages/Previews";
import Settings from "./pages/Settings";
import BuildDetails from './pages/BuildDetails';

// ADMIN
import AdminLogin from "./admin/pages/Login";
import Dashboard from "./admin/pages/Dashboard";
import AdminRoute from "./admin/AdminRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* USER ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/builds" element={<Builds />} />
        {/* <Route path="/build-status" element={<BuildStatus />} /> */}
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/previews" element={<Previews />} />
        <Route path="/settings" element={<Settings />} />
         {/* ✅ ADD THIS LINE */}
        <Route path="/build-status/:id" element={<BuildStatus />} />
        <Route path="/builds/:id" element={<BuildDetails />} />

        {/* ADMIN */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <AdminRoute>
              <Dashboard />
            </AdminRoute>
          }
        />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;